import React from 'react';
import { Button, Card } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        this.setState({ errorInfo });
    }

    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        if (this.props.onReset) {
            this.props.onReset();
        }
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return (
                <Card className="shadow-sm border-danger m-3 bg-white">
                    <Card.Body className="p-4 text-center">
                        <div className="fs-1 mb-2">⚠️</div>
                        <h4 className="fw-bold text-danger mb-2">
                            {this.props.title || "Ocurrió un error al cargar esta sección"}
                        </h4>
                        <p className="text-muted small mb-3">
                            {this.state.error?.message || "Error desconocido en tiempo de ejecución."}
                        </p>
                        <div className="d-flex justify-content-center gap-2">
                            <Button variant="outline-primary" size="sm" onClick={this.handleReset}>
                                🔄 Reintentar
                            </Button>
                            {this.props.onNavigateHome && (
                                <Button variant="secondary" size="sm" onClick={this.props.onNavigateHome}>
                                    Volver al Despacho
                                </Button>
                            )}
                        </div>
                    </Card.Body>
                </Card>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
